import type { FormDefinition } from './types'

export default {
  sections: {
    Mitglied: {
      fields: [
        { id: 'Mitglied.Vorname', control: 'text-or-date' },
        { id: 'Mitglied.Nachname', control: 'text-or-date' },
        { id: 'Mitglied.E-Mail', control: 'text-or-date' },
      ],
    },
    'Rolle & Status': {
      fields: [
        { id: 'Rolle & Status.Rolle', control: 'display' },
        { id: 'Rolle & Status.Status', control: 'display' },
        { id: 'Rolle & Status.Mitglied seit', control: 'display' },
        { id: 'Rolle & Status.Eingeladen von', control: 'display' },
      ],
    },
  },
} satisfies FormDefinition
